import { ProfileButton } from "./ProfileButton";
import { useEffect } from "react";
import { GButton } from "../../../components/GButton";
import styles from "./css/SignInButton.module.css";
import { update } from "../../../common/state/Slices/AuthSlice";
import { useAppDispatch, useAppSelector } from "../../../common/state/hooks";
import { KeycloakClientFactory } from "../../../helper/keycloak/factory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

const SignInButton = () => {
  const keycloak = KeycloakClientFactory.getInstance();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.authenticated);

  useEffect(() => {
    async function initializeKeyCloak() {
      if (!isAuthenticated) {
        try {
          const keycloak = KeycloakClientFactory.getInstance();
          const authenticated = await keycloak.init();
          dispatch(update({ authenticated: authenticated }));
        } catch (error) {
          console.error("Failed to complete authentication flow:", error);
        }
      }
    }
    initializeKeyCloak();
  }, [dispatch, isAuthenticated]);

  const showSignInPage = () => {
    keycloak.login();
  };

  return isAuthenticated === true ? (
    <ProfileButton />
  ) : (
    <GButton
      data-testid="sign-in-btn"
      className={styles.signBtn}
      onClick={showSignInPage}
      color="primary"
      variant="contained"
      startIcon={<FontAwesomeIcon icon={faRightFromBracket} />}
    >
      Sign In {isAuthenticated}
    </GButton>
  );
};

export default SignInButton;
